export default function useGetFileSize() {
  function getFileSize(file) {
    if (!file) {
      return '';
    }

    const { size = null } = file;
    if (!size) {
      return '';
    }

    let displaySize = '';

    if (size < 1024) {
      displaySize = `${size.toFixed(1)} bytes`;
    } else if (size < 1024 ** 2) {
      displaySize = `${(size / 1024).toFixed(1)} KB`;
    } else if (size < 1024 ** 3) {
      displaySize = `${(size / 1024 ** 2).toFixed(1)} MB`;
    } else if (size < 1024 ** 4) {
      displaySize = `${(size / 1024 ** 3).toFixed(1)} GB`;
    }

    return displaySize;
  }

  return getFileSize;
}
